import React, { Component } from 'react'
import { PropTypes } from 'prop-types'
import { compose } from 'recompose'
import { get } from 'lodash'
import { connect } from 'react-redux'

import { permissions as permissionsHelper } from 'helpers/decorators'
import { awards as awardsLayout } from 'constants/layout'
import { CONFIGURATION_KEYS } from 'constants/enums'
import { apiTasksOverview } from 'helpers/decorators/api'
import { renderRoutes } from 'react-router-config'

const enhance = compose(
  permissionsHelper(),
  apiTasksOverview({
    overview: true
  }),
  connect(state => ({
    configuration: state.api.configuration
  }))
)

class Awards extends Component {
  static propTypes = {
    children: PropTypes.any.isRequired,
    tabs: PropTypes.any,
    permissions: PropTypes.object.isRequired,
    configuration: PropTypes.object.isRequired,
    tasks: PropTypes.object.isRequired,
    activeOrganization: PropTypes.object.isRequired,
    route: PropTypes.object
  }

  render() {
    const { permissions, children, tabs, tasks, activeOrganization, route } = this.props
    const activeOrganizationId = activeOrganization.id
    const activeOrganizationConfigs = get(
      this.props.configuration,
      `valuesByOrganizationId[${activeOrganizationId}]`,
      {}
    )
    const canActiveOrganizationSelfSign = get(
      activeOrganizationConfigs[CONFIGURATION_KEYS.allowSelfSign.id],
      'booleanValue',
      false
    )

    return (
      <div>
        {(permissions.isGbt || canActiveOrganizationSelfSign) &&
          tabs &&
          React.cloneElement(tabs, {
            links: awardsLayout.tabs(canActiveOrganizationSelfSign),
            overview: tasks.overview
          })}
        {children}
        {renderRoutes(route.routes, this.props)}
      </div>
    )
  }
}

export default enhance(Awards)
